// Resolve an absolute-looking path against Vite's configured base URL.
// On a regular host the base is "/" so it's a no-op; under GitHub Pages it becomes
// e.g. "/UBeat/" and we prepend that. External (http/https) URLs are returned untouched.

const RAW = import.meta.env.BASE_URL || '/';
const BASE = RAW.endsWith('/') ? RAW.slice(0, -1) : RAW;

export function withBase(p: string): string {
  if (!p) return p;
  if (/^https?:/i.test(p)) return p;
  return BASE + (p.startsWith('/') ? p : '/' + p);
}
